import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import Checkbox from '../Checkbox';
import styles from './KidsFreeBlock.module.scss';
import { InputType } from '../../utils/@globalTypes';
import { kidsAgeMask } from '../../utils/constants';
import Input from '../Input';
import { FeedingSettingsType } from '../../redux/types/mainObjectTypes';
import { PriceFormType } from '../../redux/types/pricesTypes';

const KidsFreeBlock = () => {
  const {
    handleChange,
    values,
    errors,
    setFieldTouched,
    touched,
    validateField,
    setFieldValue,
  } = useFormikContext<FeedingSettingsType | PriceFormType>();

  useEffect(() => {
    if (touched.ageKidsFree) {
      validateField('ageKidsFree');
    }
  }, [values.ageKidsFree]);

  useEffect(() => {
    if (!values.has_kidsPrice) {
      setFieldValue('ageKidsFree', '');
    }
  }, [values.has_kidsPrice]);

  return (
    <div className={styles.itemLine}>
      <span className={styles.text}>Дети младше</span>
      <div className={styles.kidsAges}>
        <Input
          id="ageKidsFree"
          name="ageKidsFree"
          placeholder="Возраст"
          type={InputType.MASK}
          mask={kidsAgeMask}
          value={values.ageKidsFree ? values.ageKidsFree : ''}
          onChange={handleChange('ageKidsFree')}
          errText={errors.ageKidsFree}
          onBlur={() => setFieldTouched('ageKidsFree')}
          containerClassName={'kidsAge'}
        />
      </div>
      <span className={styles.text}>лет бесплатно</span>
    </div>
  );
};

export default KidsFreeBlock;
